import { useState } from "react";
import axios from "../../../config/axios";
import {
  Box,
  TextField,
  Snackbar,
  Alert,
  Grid,
  Stack,
  Paper,
  Chip,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import Button from "../../../components/CommonButton";
import CommonDialog from "../../../components/CommonDialog";
import FormLabel from "../../../components/FormLabel";

const AddExpertiseModal = (props) => {
  const [validations, setValidations] = useState({
    name: { status: false, msg: "" },
  });
  const [skills, setSkills] = useState([]);
  const [name, setName] = useState("");
  const [newSkill, setNewSkill] = useState("");
  const [alertMsg, setAlertMsg] = useState({ status: false });

  // other functions
  const handleSubmit = () => {
    addExpertise();
  };

  const handleAlertClose = () => {
    setAlertMsg({ status: false, msg: "", severity: "" });
    props.setOpen((prevState) => ({ ...prevState, addExpertise: false }));
  };

  const handleAlert = (severity, msg) => {
    setAlertMsg({ status: true, msg, severity });
  };

  // ** API Services **//
  const addExpertise = () => {
    let hasError = false;
    let currentSkills = [...skills];
    let tempValidations = { ...validations };

    if (!name.trim()) {
      tempValidations.name = { status: true, msg: "Expertise name is required!" };
      hasError = true;
    } else {
      tempValidations.name = { status: false, msg: "" };
    }

    if (newSkill.trim().length) {
      currentSkills.push(newSkill);
      setSkills(currentSkills);
      setNewSkill("");
      tempValidations.skills = { status: false, msg: "" };
    } else if (currentSkills.length === 0) {
      tempValidations.skills = { status: true, msg: "At least one skill is required!" };
      hasError = true;
    } else {
      tempValidations.skills = { status: false, msg: "" };
    }

    setValidations(tempValidations);

    if (hasError) return;

    const body = { name: name, skills: currentSkills };

    axios
      .post("/admin/expertises", body)
      .then((res) => {
        if (res.status === 200) {
          if (res.data.status) {
            setValidations({});
            setNewSkill("");
            setSkills([]);
            setName("");
            props.fetchExpertiseOptions();
            handleAlert("success", "Expertise added successfully!");
          }
          if (!res.data.status && res.data.type === "validation") {
            setValidations({
              name: { status: true, msg: res.data.msg },
            });
          }
          if (!res.data.status && res.data.error) {
            const tempValidations = {};
            res.data.error.forEach((err) => {
              tempValidations[err.field] = { status: true, msg: err.message };
            });
            setValidations({ ...tempValidations });
          }
        }
      })
      .catch((err) => console.log(err));
  };

  return (
    <>
      <CommonDialog
        open={props.open.addExpertise}
        title={"Add Expertise"}
        onSubmit={handleSubmit}
        onClose={() => props.setOpen({ ...props.open, addExpertise: false })}
      >
        <Paper style={{ ...props.style, width: "100%" }} elevation={0}>
          <Box sx={{ padding: "10px" }}>
            <Stack spacing={1}>
              <Grid container>
                <Grid xs={12} sm={12} md={12} lg={12} xl={12} item>
                  <FormLabel title="Expertise" />
                  <TextField
                    required
                    size="small"
                    value={name}
                    onChange={(e) => {
                      setName(e.target.value);
                      if (validations.name?.status) {
                        setValidations((prevState) => ({
                          ...prevState,
                          name: { status: false, msg: "" },
                        }));
                      }
                    }}
                    error={validations.name?.status}
                    helperText={validations.name?.msg}
                    sx={{ width: "100%" }}
                    placeholder="Expertise Name"
                  />
                </Grid>
              </Grid>
              <Grid container>
                <Grid xs={12} item>
                  <FormLabel title="Skill" />
                  <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1 }}>
                    <TextField
                      size="small"
                      value={newSkill}
                      onChange={(e) => {
                        setNewSkill(e.target.value);
                        if (validations.newSkill?.status) {
                          setValidations((prevState) => ({
                            ...prevState,
                            newSkill: { status: false, msg: "" },
                          }));
                        }
                      }}
                      error={validations.skills?.status}
                      helperText={validations.skills?.msg}
                      sx={{ flexGrow: 1 }}
                      placeholder="Skill Name"
                    />
                    <Button
                      variant="contained"
                      onClick={() => {
                        if (newSkill.length) {
                          setSkills((prevState) => [...prevState, newSkill]);
                          setNewSkill("");
                          if (validations.skills?.status) {
                            setValidations((prevState) => ({
                              ...prevState,
                              skills: { status: false, msg: "" },
                            }));
                          }
                        } else {
                          setValidations((prevState) => ({
                            ...prevState,
                            skills: { status: true, msg: "Required!" },
                          }));
                        }
                      }}
                      sx={{ flexShrink: 0, height: "40px" }}
                    >
                      Add
                    </Button>
                  </Box>
                </Grid>
              </Grid>
              <Grid container>
                <Grid
                  xs={11}
                  sm={11}
                  md={11}
                  lg={11}
                  xl={11}
                  item
                  sx={{ display: "flex", flexWrap: "wrap" }}
                >
                  {skills.map((sk) => (
                    <Chip
                      variant="outlined"
                      sx={{ margin: "8px" }}
                      deleteIcon={<DeleteIcon />}
                      onDelete={() => {
                        const index = skills.indexOf(sk);
                        setSkills((prevState) => {
                          prevState.splice(index, 1);
                          return [...prevState];
                        });
                      }}
                      color="primary"
                      label={sk}
                    />
                  ))}
                </Grid>
              </Grid>
            </Stack>
          </Box>
        </Paper>
      </CommonDialog>
      <Snackbar
        open={alertMsg.status}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        autoHideDuration={100}
        onClose={handleAlertClose}
      >
        <Alert severity={alertMsg.severity} sx={{ width: "100%" }}>
          {alertMsg.msg}
        </Alert>
      </Snackbar>
    </>
  );
};

export default AddExpertiseModal;
